import React, { useState } from 'react';
import {
  Badge,
  Button,
  Icon,
  Toolbar, Tooltip
} from '@material-ui/core';
import ViewColumn from 'helpers/ViewColumn';
import useStyles from '../styles';
import { searchFields } from './helpers/mapped';
import DataMappingSearchBar from './DataMappingSearchBar';
import DataMappingFilterDrawer from './DataMappingFilterDrawer';


const DataMappingTableToolbar = ({
  search,
  onSearch,
  filters,
  setFilters,
  tableCells,
  setHeadTableCells
}) => {
  const [openFilterDrawer, setOpenFilterDrawer] = useState(false);
  const classes = useStyles();
  return (
    <Toolbar className="w-full relative bg-white p-3 flex justify-between">
      <div className="flex items-center">
        <DataMappingSearchBar
          onSearch={onSearch}
          searchFields={searchFields}
          filters={filters}
        />
        <Badge
          badgeContent={Object.keys(filters).length}
          color="primary"
          overlap="rectangular"
        >
          <Tooltip title="Filter by">
            <Button
              variant="outlined"
              color="primary"
              className={`uppercase font-bold ${classes.toolbarButtonGutters}`}
              onClick={() => setOpenFilterDrawer(true)}
            >
              <Icon className="mr-2 text-primary">
                filter_list
              </Icon>
              <span className="text-primary">Filter By</span>
            </Button>
          </Tooltip>
        </Badge>
      </div>
      <ViewColumn
        storageKey="DataMappingTableCells"
        tableCells={tableCells}
        setHeadTableCells={setHeadTableCells}
        iconColor="#32324D"
      />
      <DataMappingFilterDrawer
        filters={filters}
        setFilters={setFilters}
        search={search}
        openFilterDrawer={openFilterDrawer}
        setOpenFilterDrawer={setOpenFilterDrawer}
      />
    </Toolbar>
  );
};

export default DataMappingTableToolbar;
